import React, { memo } from 'react';
import * as PropTypes from 'prop-types';
import useUiContext from '@groupefungo/react-apollo.core/ui/UseContext';

const AppointmentTypeSelect = ({ label, name, value, error, onChange, disabled, dressType, appointmentTypes, alterations = false }) => {
  const { SelectMui } = useUiContext();
  const getAppointmentTypes = () => {
    if (dressType === '-1' && alterations) {
      return appointmentTypes;
    }
    return appointmentTypes.filter((t) => t.includes(dressType.split('/')[0]));
  };
  return (
    <SelectMui
      id="appointment_type_select"
      label={label}
      disabled={disabled}
      name={name}
      value={value}
      error={error}
      onChange={onChange}
      options={getAppointmentTypes()}
      MenuProps={{
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left',
        },
        getContentAnchorEl: null,
        // classes: { paper: menuClasses.menuPaper },
      }}
    />
  );
};

AppointmentTypeSelect.defaultProps = {
  label: 'Appointment Type',
  disabled: false,
  name: 'appointmentType',
  error: false,
};
AppointmentTypeSelect.propTypes = {
  label: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  error: PropTypes.bool,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  dressType: PropTypes.string.isRequired,
  appointmentTypes: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default memo(AppointmentTypeSelect);
